import React from 'react';

/**
 * When the user clicks outside the component that uses the UseOutsideClick hook, it triggers a function inside that component.
 */

const useOutsideClick = (callback) => {
  const ref = React.useRef<HTMLDivElement>(null);

  React.useEffect(() => {
    const handleClick = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        callback();
      }
    };
    document.addEventListener('click', handleClick);
    return () => {
      document.removeEventListener('click', handleClick);
    };
  }, [ref]);
  return ref;
};

export default useOutsideClick;
